import { computePosition, flip, shift, offset } from '@floating-ui/dom';

const tooltip = () => {
    const wrappers = document.querySelectorAll('.tooltip-wrapper');

    if (wrappers.length === 0) {
        return;
    }

    wrappers.forEach(wrapper => {
        const trigger = wrapper.querySelector('.tooltip-trigger');
        const tooltipEl = wrapper.querySelector('.tooltip');

        if (!trigger || !tooltipEl) {
            return;
        }

        function show() {
            tooltipEl.classList.add('show');

            computePosition(trigger, tooltipEl, {
                placement: 'top',
                middleware: [offset(10), flip(), shift({ padding: 5 })]
            }).then(({x, y, placement}) => {
                Object.assign(tooltipEl.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                });
                tooltipEl.dataset.placement = placement;
            });
        }

        function hide() {
            tooltipEl.classList.remove('show');
        }

        trigger.addEventListener('mouseenter', show);
        trigger.addEventListener('mouseleave', hide);
        trigger.addEventListener('focus', show);
        trigger.addEventListener('blur', hide);
    });
};

export default tooltip;
